export const Permission_Message= <div className='d-flex justify-content-center mt-5 me-5'><h6>You don't have permission to access</h6></div>